// Hoisted so it isn't recreated on every render (react-perf/jsx-no-new-array-as-prop).
export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];
